<template>
  <div class="page news-detail">
    <div v-loading="loading" class="page-body page-body--narrow">
      <div class="detail-nav">
        <el-button type="text" icon="el-icon-arrow-left" @click="$router.push('/news')">
          返回资讯列表
        </el-button>
      </div>
      <template v-if="detail">
        <div class="detail-header">
          <div class="detail-header__top">
            <el-tag v-if="detail.tag" type="danger" effect="plain" size="small">{{ detail.tag }}</el-tag>
            <span class="detail-date">{{ formatDate(detail.publishTime) }}</span>
          </div>
          <h1>{{ detail.title }}</h1>
          <p v-if="detail.summary" class="detail-summary">{{ detail.summary }}</p>
        </div>
        <div v-if="detail.content" class="detail-content">
          <rich-content :content="detail.content" />
        </div>
        <p v-else-if="detail.summary" class="detail-content detail-content--text">{{ detail.summary }}</p>
      </template>
      <div v-else-if="!loading" class="page-empty">
        <i class="el-icon-warning-outline" />
        <p>资讯不存在或已下架</p>
        <el-button type="text" @click="$router.push('/news')">返回列表</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import RichContent from '@/components/RichContent.vue';
import { getNews } from '@/api/news';
import { formatDate } from '@/utils/format';
import { resolveImageUrl } from '@/utils/image';
import { updateSeo } from '@/utils/seo';

export default {
  name: 'NewsDetail',
  components: { RichContent },
  data() {
    return {
      loading: false,
      detail: null
    };
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler() {
        this.loadDetail();
      }
    }
  },
  methods: {
    formatDate,
    loadDetail() {
      const id = this.$route.params.id;
      if (!id) return;
      this.loading = true;
      this.detail = null;
      getNews(id)
        .then(res => {
          this.detail = res.data || null;
          if (this.detail) {
            updateSeo({
              title: this.detail.title,
              description: this.detail.summary || this.detail.title,
              keywords: [this.detail.tag, this.detail.title, '百年票票', '西安旅游资讯'].filter(Boolean).join(','),
              image: this.detail.coverImage ? resolveImageUrl(this.detail.coverImage) : '/logo.png',
              type: 'article'
            });
          }
        })
        .catch(() => {
          this.detail = null;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.detail-nav {
  margin: -8px 0 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #ebeef5;
}
.detail-nav .el-button--text {
  padding-left: 0;
  color: #606266;
  font-size: 14px;
}
.detail-nav .el-button--text:hover {
  color: #c41e3a;
}
.detail-header__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}
.detail-date {
  font-size: 13px;
  color: #909399;
}
.detail-header h1 {
  margin: 0 0 14px;
  font-size: 26px;
  color: #303133;
  line-height: 1.45;
}
.detail-summary {
  margin: 0;
  font-size: 15px;
  line-height: 1.8;
  color: #909399;
  padding-bottom: 20px;
  border-bottom: 1px dashed #ebeef5;
}
.detail-content {
  margin-top: 24px;
}
.detail-content--text {
  font-size: 15px;
  line-height: 1.9;
  color: #606266;
}
@media (max-width: 768px) {
  .detail-header h1 {
    font-size: 20px;
  }
}
</style>
